import { RegisterV2RequestT } from '@consumer-frontend/nc-api';
import {
  isDefined,
  marriedStatuses,
  RegistrationDataT,
} from '@consumer-frontend/nc-utils';

import { VerifyIdentityFormValuesT } from './NcVerifyIdentityForm';

// Maps the in-progress registration data plus the verify-identity form's date of birth into the
// register v2 endpoint payload, including the marital-status and spouse-address fields when present.
export const buildRegisterV2Request = (
  registrationData: Partial<RegistrationDataT>,
  dateOfBirth: VerifyIdentityFormValuesT['dateOfBirth'],
): RegisterV2RequestT => {
  const { address, maritalInformation } = registrationData;
  const maritalStatus = maritalInformation?.maritalStatus;
  const includeSpouseInfo = isDefined(maritalInformation)
    && marriedStatuses.includes(maritalInformation.maritalStatus);

  const spouse = maritalInformation?.spouse;
  const spouseAddress = spouse?.sameAddress ? address : spouse?.address;

  return {
    city: address?.city || '',
    date_of_birth: dateOfBirth?.toString() || '',
    first_name: registrationData.firstName || '',
    home_address: address?.addressLine1 || '',
    last_name: registrationData.lastName || '',
    main_phone: registrationData.phoneNumber || '',
    postal_code: address?.postalCode || '',
    state: address?.state || '',
    ...(address?.addressLine2 && { apt_or_unit: address.addressLine2 }),
    ...(maritalStatus && { marital_status: maritalStatus }),
    ...(includeSpouseInfo && spouse && {
      spouse_first_name: spouse.firstName,
      spouse_last_name: spouse.lastName,
      ...(spouseAddress && {
        spouse_city: spouseAddress.city,
        spouse_home_address: spouseAddress.addressLine1,
        spouse_postal_code: spouseAddress.postalCode,
        spouse_state: spouseAddress.state,
        ...(spouseAddress.addressLine2 && { spouse_apt_or_unit: spouseAddress.addressLine2 }),
      }),
    }),
  };
};
